import { PropsWithClassname } from "@/types";
import { resizeImage } from "@/util/image";
import { toText } from "@/util/toText";
import { Chip } from "@/ui/Chip";
import { Comment } from "@/ui/icons/Comment";
import { cn, Image } from "@heroui/react";
import { useTranslations } from "next-intl";
import numeral from 'numeral';
import { PropsWithChildren, ReactNode } from "react";

export const EmptyCard = ({ children, className, ...other }: PropsWithChildren & PropsWithClassname & { [key in string]: any }) => {
  return (
    <div className={"relative group w-full flex flex-col max-w-[240px] flex-1  p-[12px] bg-light-gray rounded-[12px] select-none " + className} {...other}>
      {children}
    </div >
  )
}

export const Card = ({
  imgUrl, tags = [], desc, name, comments,
  author, imageMask, footer, className = "", ...other }:
  { [key in string]: any } &
  { footer?: ReactNode, imageMask?: ReactNode }) => {

  const t = useTranslations()

  const nameText = toText(name)
  const descText = toText(desc)

  return (
    <EmptyCard className={cn(
      "hover:bg-card-hover-bg",
      className)} {...other}>
      <div className="w-full relative rounded-[12px] overflow-hidden">
        <Image
          classNames={{
            wrapper: "w-full h-full aspect-square !max-w-full  overflow-hidden",
            img: "object-cover h-full w-full"
          }}
          alt={nameText}
          src={resizeImage(imgUrl, 200)}
          radius="none"
        />
        {imageMask}
      </div>

      <p className="mt-2 pt-1 font-bold text-theme-primary text-wrap break-words leading-[1] line-clamp-1 text-[14px]">{nameText}</p>
      <p className="text-[12px] mt-[4px] text-theme-primary/70 break-words text-wrap line-clamp-2 font-[400]	leading-[14px]">{descText}</p>
      <div className="mt-[8px] line-clamp-2 leading-[1]">
        {tags?.map((item: any) =>
          <Chip
            key={item}
            className="!bg-card-chip-bg !inline-block text-[12px] mr-[2px] !text-theme-primary !font-[400] leading-[24px] line-clamp-1">
            {item}
          </Chip>)}
      </div>

      {
        footer || (<div className="mt-[10px] text-theme-primary/70 flex-1 items-end text-[12px] flex gap-[10px] justify-between">

          <div className="flex items-center">
            <Comment />
            <span className="ml-[4px]">{numeral(comments).format('0a')}</span>
          </div>
          <div className="text-[12px]">
            <span className="line-clamp-1 break-all">{t('common.by')}{toText(author)}</span>
          </div>
        </div>)
      }
    </EmptyCard>


  )
}